module.exports = __webpack_public_path__ + "static/media/photo312.d365fec3.jpg";